// extracted by mini-css-extract-plugin
export default {"wrapper":"rich-text-expandable-text-module--wrapper--64883"};